import { IBeginPurchaseRequest } from "../entities-generated/models/pending-transaction/begin-purchase-request";
import { IBeginPurchaseResponse } from "../entities-generated/models/pending-transaction/begin-purchase-response";
import { IDevProcessTransactionResultRequest } from "../entities-generated/models/pending-transaction/dev-process-transaction-result-request";
import { IGetTransactionResultResponse } from "../entities-generated/models/pending-transaction/get-transaction-result-response";
import { ApiClient } from "./shop-api-client";

class PaymentApiClientClass {
  public beginPurchase(request: IBeginPurchaseRequest) {
    return ApiClient.post<IBeginPurchaseResponse>(`payment/start`, request);
  }

  public getTransactionResult(transactionId: string) {
    return ApiClient.get<IGetTransactionResultResponse>(`payment/status/${transactionId}`);
  }

  public devProcessTransactionResult(request: IDevProcessTransactionResultRequest) {
    return ApiClient.post<void>('payment/dev/telecast-sim', request);
  }
}

export const PaymentApiClient = new PaymentApiClientClass();